import React from 'react'

import { Icon, FilterIcon, Button, Close } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import ResetFiltersAction from '../../../ResetFiltersAction'

function RemainingFiltersOverlay({ children, closeOverlay, locale = 'en' }) {
  const allFiltersLabel = i18n.t('listingPage.filters.allFilters', { ns: 'rails', lng: locale })

  return (
    <div className="remaining-filters-overlay">
      <div className="remaining-filters-overlay__header">
        <div className="remaining-filters-overlay__header-title">
          <Icon svgComponent={FilterIcon} color="dark" />
          <span>{allFiltersLabel}</span>
        </div>

        <div className="remaining-filters-overlay__header-actions">
          <ResetFiltersAction isLink />
          <Button
            type="secondary"
            variant="only-icon"
            icon={<Icon svgComponent={Close} notSpaced />}
            onClick={closeOverlay}
          />
        </div>
      </div>

      <div className="remaining-filters-overlay__content">{children}</div>
    </div>
  )
}

RemainingFiltersOverlay.propTypes = {
  closeOverlay: func.isRequired,
  locale: string,
}

export default RemainingFiltersOverlay
